<template>
  <v-alert :type="getAlertType(vigenciaFormacion)" dense :color="getAlertColor(vigenciaFormacion)">
    {{ getAlertText(vigenciaFormacion) }}
  </v-alert>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    vigenciaFormacion: {
      type: String,
    },
  },
  data() {
    return {
      API_DATE_FORMAT: 'YYYY-MM-DD',
    }
  },
  methods: {
    getAlertType(fecha_vigencia) {
      if (fecha_vigencia !== '') {
        const meses = moment(fecha_vigencia, this.API_DATE_FORMAT).diff(moment(), 'months', true)
        if (meses > 7) return 'success'
        if (meses <= 7 && meses >= 5) return 'warning'
        if (meses < 5) return 'error'
      }
      return 'info'
    },
    getAlertColor(fecha_vigencia) {
      if (fecha_vigencia !== '') {
        const meses = moment(fecha_vigencia, this.API_DATE_FORMAT).diff(moment(), 'months', true)
        if (meses > 7) return 'green'
        if (meses <= 7 && meses >= 5) return 'yellow darken-2'
        if (meses < 5) return 'rgb(176, 0, 32)'
      }
      return 'blue-grey'
    },
    getAlertText(fecha_vigencia) {
      if (fecha_vigencia !== '') {
        return 'Formación inicial: ' + this.getDateText(fecha_vigencia)
      } else return 'Formación inicial: Fecha no registrada'
    },
    getDateText(fecha) {
      return moment(fecha, this.API_DATE_FORMAT).format('DD/MM/YYYY')
    },
  },
}
</script>
